import { useState } from 'react';
import { User } from '@prisma/client';
import { Button, Card, Descriptions, Tag } from 'antd';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

import { useEmployeeTypeTag } from '../common';
import { EvidenceModal } from '../subscriptions/modals';

export const WorkerCard = ({ worker }: { worker: User }) => {
  const { user } = Auth.useUserAuth();
  const { getProps } = useEmployeeTypeTag(worker.employeeType);
  const [show, setShow] = useState(false);

  return (
    <Card
      extra={
        <Button type="link" onClick={() => setShow((value) => !value)}>
          {show ? 'Less' : 'More'}
        </Button>
      }
      size="small"
      title="Worker"
    >
      {show ? (
        <Descriptions
          bordered
          column={1}
          items={[
            {
              key: 'name',
              label: 'Name',
              children: (
                <span>
                  {worker.name} <Tag {...getProps({ style: { marginLeft: '1em' } })} />
                </span>
              ),
            },
            { key: 'wwid', label: 'WWID', children: worker.enterpriseId },
            {
              key: 'email',
              label: 'Email',
              children: <a href={`mailto:${worker.email}`}>{worker.email}</a>,
            },
            { key: 'idsid', label: 'IDSID', children: worker.idsid },
            ...(user?.roles[Role.SYSTEM_ADMIN]
              ? [
                  {
                    key: 'evidence',
                    label: 'SYSTEM ADMIN ONLY',
                    children: <EvidenceModal enterpriseId={worker.enterpriseId} />,
                  },
                ]
              : []),
          ]}
          size="small"
        />
      ) : (
        <span>
          {worker.name} <Tag {...getProps({ style: { marginLeft: '1em' } })} />
        </span>
      )}
    </Card>
  );
};
